export { default } from './MobilsTauletes';
